'use client';

import { faro } from '@grafana/faro-web-sdk';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

/**
 * Tracks Next App Router navigations as Faro views. faro-react's router
 * instrumentation is React-Router-only and never fires here, so we drive
 * setView() from usePathname() ourselves.
 */
export function FaroRouteTracker() {
  const pathname = usePathname();

  useEffect(() => {
    faro?.api?.setView?.({ name: pathname });
  }, [pathname]);

  return null;
}
